module.exports = __webpack_public_path__ + "media/assets/icon-mobile-menu-arrow-af94c433d32dfcda6e453600ba7927c1.svg";